export function createMarketEventCandleTimeStamp({
  nextCandleTimeStampRef,
  currentCandleTimeStamp,
  millisBetweenCandles,
  timeUnit,
}) {
  if (timeUnit !== 'MINUTES') {
    const tempTimeStamp = nextCandleTimeStampRef.current;
    nextCandleTimeStampRef.current =
      nextCandleTimeStampRef.current + millisBetweenCandles;
    return tempTimeStamp;
  }

  const nextScheduledTimeStamp = Number(nextCandleTimeStampRef.current);
  const marketEventTimeStamp = Number(currentCandleTimeStamp);
  const interval = Number(millisBetweenCandles);

  if (
    !Number.isFinite(nextScheduledTimeStamp) ||
    !Number.isFinite(marketEventTimeStamp) ||
    !Number.isFinite(interval) ||
    interval <= 0
  ) {
    return nextCandleTimeStampRef.current;
  }

  const intervalsSinceNext = Math.max(
    Math.floor((marketEventTimeStamp - nextScheduledTimeStamp) / interval),
    0
  );
  const candleTimeStamp = nextScheduledTimeStamp + intervalsSinceNext * interval;
  nextCandleTimeStampRef.current = candleTimeStamp + interval;
  return candleTimeStamp;
}
